import { createApiSlice } from "@common";
import { CRUD_ACCOUNT_CATEGORY } from "@routes";

const apiConfig = [
  {
    name: "addAccountCategory",
    method: "post",
    url: CRUD_ACCOUNT_CATEGORY,
    stateKey: "message",
  },
  {
    name: "getAccountCategory",
    method: "get",
    url: CRUD_ACCOUNT_CATEGORY,
    stateKey: "data",
  },
  {
    name: "updateAccountCategory",
    method: "put",
    url: CRUD_ACCOUNT_CATEGORY,
    stateKey: "message",
  },
  {
    name: "deleteAccountCategory",
    method: "delete",
    url: CRUD_ACCOUNT_CATEGORY,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"accountCategory",
 apiConfig, 
 customReducers);
const accountCategorySlice = slice;

export default accountCategorySlice.reducer;

export const {
  addAccountCategory,
  getAccountCategory,
  updateAccountCategory,
  deleteAccountCategory,
} = thunks;

export const { rowSelect } = actions;
